import * as yup from 'yup';

import { FORM_KEYS, NO_OF_CHARS } from 'shared/constant';

const { FATCA } = FORM_KEYS;

/** e.g. format: +9651234123451 */
const phoneRegExp = /^\+(?:[0-9] ?){6,14}[0-9]$/;

const fatcaQ1Schema = intl => yup.object().shape({
  [FATCA.FATCA_Q1]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
});

const translateAnswer = (str, intl) => {
  return str ? intl.formatMessage({ id: str.toLowerCase() }) : str;
};

/** Question no. 2 */
const fatcaQ2Schema = (intl, elementName, fatcaQ1, fatcaQ2) => {
  switch (elementName) {
    case FATCA.FATCA_Q2:
      return yup.object().shape({
        [FATCA.FATCA_Q2]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (!value && translateAnswer(fatcaQ1, intl) === intl.formatMessage({ id: 'no' })) return false;
              return true;
            },
          ),
      });
    case `${FATCA.FATCA_Q2}${FATCA.STATE}`:
      return yup.object().shape({
        [`${FATCA.FATCA_Q2}${FATCA.STATE}`]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (!value && translateAnswer(fatcaQ2, intl) === intl.formatMessage({ id: 'yes' })) return false;
              return true;
            },
          )
          .min(NO_OF_CHARS.SMALLEST_MIN, intl.formatMessage({ id: 'validation.mustBeMinimum' }, { number: NO_OF_CHARS.SMALLEST_MIN }))
          .max(NO_OF_CHARS.SMALLEST_MAX, intl.formatMessage({ id: 'validation.mustBeMaximum' }, { number: NO_OF_CHARS.SMALLEST_MAX })),
      });
    case `${FATCA.FATCA_Q2}${FATCA.CITY}`:
      return yup.object().shape({
        [`${FATCA.FATCA_Q2}${FATCA.CITY}`]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (!value && translateAnswer(fatcaQ2, intl) === intl.formatMessage({ id: 'yes' })) return false;
              return true;
            },
          )
          .min(NO_OF_CHARS.SMALLEST_MIN, intl.formatMessage({ id: 'validation.mustBeMinimum' }, { number: NO_OF_CHARS.SMALLEST_MIN }))
          .max(NO_OF_CHARS.SMALLEST_MAX, intl.formatMessage({ id: 'validation.mustBeMaximum' }, { number: NO_OF_CHARS.SMALLEST_MAX })),
      });
    default:
      return null;
  }
};

/** Question no. 3 */
const fatcaQ3Schema = (intl, elementName, fatcaQ1, fatcaQ3) => {
  switch (elementName) {
    case FATCA.FATCA_Q3:
      return yup.object().shape({
        [FATCA.FATCA_Q3]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (!value && translateAnswer(fatcaQ1, intl) === intl.formatMessage({ id: 'no' })) return false;
              return true;
            },
          ),
      });
    case `${FATCA.FATCA_Q3}${FATCA.ADDRESS}`:
      return yup.object().shape({
        [`${FATCA.FATCA_Q3}${FATCA.ADDRESS}`]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (!value && translateAnswer(fatcaQ3, intl) === intl.formatMessage({ id: 'yes' })) return false;
              return true;
            },
          )
          .min(NO_OF_CHARS.MIN, intl.formatMessage({ id: 'validation.mustBeMinimum' }, { number: NO_OF_CHARS.MIN }))
          .max(NO_OF_CHARS.MAX, intl.formatMessage({ id: 'validation.mustBeMaximum' }, { number: NO_OF_CHARS.MAX })),
      });
    case `${FATCA.FATCA_Q3}${FATCA.US_PHONE}`:
      return yup.object().shape({
        [`${FATCA.FATCA_Q3}${FATCA.US_PHONE}`]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (!value && translateAnswer(fatcaQ3, intl) === intl.formatMessage({ id: 'yes' })) return false;
              return true;
            },
          )
          .min(NO_OF_CHARS.MIN_MOBILE, intl.formatMessage({ id: 'validation.mustBeMinimum' }, { number: NO_OF_CHARS.MIN_MOBILE }))
          .matches(phoneRegExp, intl.formatMessage({ id: 'validation.invalidMobileFormat' })),
      });
    default:
      return null;
  }
};

/** Question no. 4 */
const fatcaQ4Schema = (intl, elementName, fatcaQ1, fatcaQ4) => {
  switch (elementName) {
    case FATCA.FATCA_Q4:
      return yup.object().shape({
        [FATCA.FATCA_Q4]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (!value && translateAnswer(fatcaQ1, intl) === intl.formatMessage({ id: 'no' })) return false;
              return true;
            },
          ),
      });
    case `${FATCA.FATCA_Q4}${FATCA.ADDRESS}`:
      return yup.object().shape({
        [`${FATCA.FATCA_Q4}${FATCA.ADDRESS}`]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (!value && translateAnswer(fatcaQ4, intl) === intl.formatMessage({ id: 'yes' })) return false;
              return true;
            },
          )
          .min(NO_OF_CHARS.MIN, intl.formatMessage({ id: 'validation.mustBeMinimum' }, { number: NO_OF_CHARS.MIN }))
          .max(NO_OF_CHARS.MAX, intl.formatMessage({ id: 'validation.mustBeMaximum' }, { number: NO_OF_CHARS.MAX })),
      });
    default:
      return null;
  }
};

/** Question no. 5 */
const fatcaQ5Schema = (intl, elementName, fatcaQ1, fatcaQ5) => {
  switch (elementName) {
    case FATCA.FATCA_Q5:
      return yup.object().shape({
        [FATCA.FATCA_Q5]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (!value && translateAnswer(fatcaQ1, intl) === intl.formatMessage({ id: 'no' })) return false;
              return true;
            },
          ),
      });
    case `${FATCA.FATCA_Q5}${FATCA.BENEFICIARY}`:
      return yup.object().shape({
        [`${FATCA.FATCA_Q5}${FATCA.BENEFICIARY}`]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (!value && translateAnswer(fatcaQ5, intl) === intl.formatMessage({ id: 'yes' })) return false;
              return true;
            },
          )
          .min(NO_OF_CHARS.SMALLEST_MIN, intl.formatMessage({ id: 'validation.mustBeMinimum' }, { number: NO_OF_CHARS.SMALLEST_MIN }))
          .max(NO_OF_CHARS.SMALLEST_MAX, intl.formatMessage({ id: 'validation.mustBeMaximum' }, { number: NO_OF_CHARS.SMALLEST_MAX })),
      });
    case `${FATCA.FATCA_Q5}${FATCA.NATIONALITY}`:
      return yup.object().shape({
        [`${FATCA.FATCA_Q5}${FATCA.NATIONALITY}`]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (!value && translateAnswer(fatcaQ5, intl) === intl.formatMessage({ id: 'yes' })) return false;
              return true;
            },
          ),
      });
    default:
      return null;
  }
};

/** Question no. 6 */
const fatcaQ6Schema = (intl, elementName, fatcaQ1, fatcaQ6) => {
  switch (elementName) {
    case FATCA.FATCA_Q6:
      return yup.object().shape({
        [FATCA.FATCA_Q6]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (!value && translateAnswer(fatcaQ1, intl) === intl.formatMessage({ id: 'no' })) return false;
              return true;
            },
          ),
      });
    case `${FATCA.FATCA_Q6}${FATCA.NAME_OF_PERSON}`:
      return yup.object().shape({
        [`${FATCA.FATCA_Q6}${FATCA.NAME_OF_PERSON}`]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (!value && translateAnswer(fatcaQ6, intl) === intl.formatMessage({ id: 'yes' })) return false;
              return true;
            },
          )
          .min(NO_OF_CHARS.SMALLEST_MIN, intl.formatMessage({ id: 'validation.mustBeMinimum' }, { number: NO_OF_CHARS.SMALLEST_MIN }))
          .max(NO_OF_CHARS.SMALLEST_MAX, intl.formatMessage({ id: 'validation.mustBeMaximum' }, { number: NO_OF_CHARS.SMALLEST_MAX })),
      });
    case `${FATCA.FATCA_Q6}${FATCA.NATIONALITY}`:
      return yup.object().shape({
        [`${FATCA.FATCA_Q6}${FATCA.NATIONALITY}`]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (!value && translateAnswer(fatcaQ6, intl) === intl.formatMessage({ id: 'yes' })) return false;
              return true;
            },
          ),
      });
    case `${FATCA.FATCA_Q6}${FATCA.ADDRESS}`:
      return yup.object().shape({
        [`${FATCA.FATCA_Q6}${FATCA.ADDRESS}`]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (!value && translateAnswer(fatcaQ6, intl) === intl.formatMessage({ id: 'yes' })) return false;
              return true;
            },
          )
          .min(NO_OF_CHARS.MIN, intl.formatMessage({ id: 'validation.mustBeMinimum' }, { number: NO_OF_CHARS.MIN }))
          .max(NO_OF_CHARS.MAX, intl.formatMessage({ id: 'validation.mustBeMaximum' }, { number: NO_OF_CHARS.MAX })),
      });
    case `${FATCA.FATCA_Q6}${FATCA.US_PHONE}`:
      return yup.object().shape({
        [`${FATCA.FATCA_Q6}${FATCA.US_PHONE}`]: yup
          .string()
          .test(
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
            (value) => {
              if (!value && translateAnswer(fatcaQ6, intl) === intl.formatMessage({ id: 'yes' })) return false;
              return true;
            },
          )
          .min(NO_OF_CHARS.MIN_MOBILE, intl.formatMessage({ id: 'validation.mustBeMinimum' }, { number: NO_OF_CHARS.MIN_MOBILE }))
          .matches(phoneRegExp, intl.formatMessage({ id: 'validation.invalidMobileFormat' })),
      });
    default:
      return null;
  }
};

/**
 * FATCA Page/Section validation
 * @param {*} intl
 * @param {*} fatcaQ1
 * @param {*} fatcaQ2
 */
const fatcaPageSchema = (intl, fatcaQ1, fatcaQ2, fatcaQ3, fatcaQ4, fatcaQ5, fatcaQ6) => yup.object().shape({
  [FATCA.FATCA_Q1]: yup
    .string()
    .required(intl.formatMessage({ id: 'validation.thisIsaRequiredField' })),
  [FATCA.FATCA_Q2]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        // console.log('fatca2 ', value, fatcaQ1);
        if (!value && translateAnswer(fatcaQ1, intl) === intl.formatMessage({ id: 'no' })) return false;
        return true;
      },
    ),
  [`${FATCA.FATCA_Q2}${FATCA.STATE}`]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!value && translateAnswer(fatcaQ2, intl) === intl.formatMessage({ id: 'yes' })) return false;
        return true;
      },
    ),
  // .min(NO_OF_CHARS.SMALLEST_MIN, intl.formatMessage({ id: 'validation.mustBeMinimum' }, { number: NO_OF_CHARS.SMALLEST_MIN }))
  // .max(NO_OF_CHARS.SMALLEST_MAX, intl.formatMessage({ id: 'validation.mustBeMaximum' }, { number: NO_OF_CHARS.SMALLEST_MAX })),
  [`${FATCA.FATCA_Q2}${FATCA.CITY}`]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!value && translateAnswer(fatcaQ2, intl) === intl.formatMessage({ id: 'yes' })) return false;
        return true;
      },
    ),
  [FATCA.FATCA_Q3]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!value && translateAnswer(fatcaQ1, intl) === intl.formatMessage({ id: 'no' })) return false;
        return true;
      },
    ),
  [`${FATCA.FATCA_Q3}${FATCA.ADDRESS}`]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!value && translateAnswer(fatcaQ3, intl) === intl.formatMessage({ id: 'yes' })) return false;
        return true;
      },
    ),
  [`${FATCA.FATCA_Q3}${FATCA.US_PHONE}`]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!value && translateAnswer(fatcaQ3, intl) === intl.formatMessage({ id: 'yes' })) return false;
        return true;
      },
    ),
  [FATCA.FATCA_Q4]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!value && translateAnswer(fatcaQ1, intl) === intl.formatMessage({ id: 'no' })) return false;
        return true;
      },
    ),
  [`${FATCA.FATCA_Q4}${FATCA.ADDRESS}`]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!value && translateAnswer(fatcaQ4, intl) === intl.formatMessage({ id: 'yes' })) return false;
        return true;
      },
    ),
  [FATCA.FATCA_Q5]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!value && translateAnswer(fatcaQ1, intl) === intl.formatMessage({ id: 'no' })) return false;
        return true;
      },
    ),
  [`${FATCA.FATCA_Q5}${FATCA.BENEFICIARY}`]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!value && translateAnswer(fatcaQ5, intl) === intl.formatMessage({ id: 'yes' })) return false;
        return true;
      },
    ),
  [`${FATCA.FATCA_Q5}${FATCA.NATIONALITY}`]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!value && translateAnswer(fatcaQ5, intl) === intl.formatMessage({ id: 'yes' })) return false;
        return true;
      },
    ),
  [FATCA.FATCA_Q6]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!value && translateAnswer(fatcaQ1, intl) === intl.formatMessage({ id: 'no' })) return false;
        return true;
      },
    ),
  [`${FATCA.FATCA_Q6}${FATCA.NAME_OF_PERSON}`]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!value && translateAnswer(fatcaQ6, intl) === intl.formatMessage({ id: 'yes' })) return false;
        return true;
      },
    ),
  [`${FATCA.FATCA_Q6}${FATCA.NATIONALITY}`]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!value && translateAnswer(fatcaQ6, intl) === intl.formatMessage({ id: 'yes' })) return false;
        return true;
      },
    ),
  [`${FATCA.FATCA_Q6}${FATCA.ADDRESS}`]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!value && translateAnswer(fatcaQ6, intl) === intl.formatMessage({ id: 'yes' })) return false;
        return true;
      },
    ),
  [`${FATCA.FATCA_Q6}${FATCA.US_PHONE}`]: yup
    .string()
    .test(
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      intl.formatMessage({ id: 'validation.thisIsaRequiredField' }),
      (value) => {
        if (!value && translateAnswer(fatcaQ6, intl) === intl.formatMessage({ id: 'yes' })) return false;
        return true;
      },
    ),
});

const fatcaSchema = {
  fatcaQ1Schema,
  fatcaQ2Schema,
  fatcaQ3Schema,
  fatcaQ4Schema,
  fatcaQ5Schema,
  fatcaQ6Schema,
  fatcaPageSchema,
};

export default fatcaSchema;
